import * as React from 'react';
import "./styles.scss"
import {ReadAndWriteContext} from "../../providers/ReadAndWriteProvider";
import {PAGES} from "../../ReadAndWrite/pages/MainContentPage";
import {Display} from "../Display";
import {canSeePage} from "../../ReadAndWrite/pages/MainContentPage/utils";

interface ReadAndWriteBlackNavBarProps {
}

export const ReadAndWriteBlackNavBar: React.FC<ReadAndWriteBlackNavBarProps> = () => {
    const {
        changePage,
        currentPage,
        getPageText,
        hasPermissionsToSeeSettings,
        hasPermissionsToEditSettings,
        IsRWSupportedCheck
    } = React.useContext(
        ReadAndWriteContext);


    const onSelected = (tabName: PAGES) => () => {
        changePage(tabName);
    }

    return <div className={"nav-bar"}>
        <ReadAndWriteBlackNavTab
            tabName={PAGES.INFO}
            text={getPageText(PAGES.INFO)}
            isSelected={PAGES.INFO === currentPage}
            onSelected={onSelected}
        />
        <Display
            isVisible={canSeePage(PAGES.SETTINGS,
                hasPermissionsToSeeSettings,
                hasPermissionsToEditSettings,
                IsRWSupportedCheck?.data?.supported)}
        >
            <ReadAndWriteBlackNavTab
                text={getPageText(PAGES.SETTINGS)}
                tabName={PAGES.SETTINGS}
                isSelected={[PAGES.SETTINGS, PAGES.UPDATING, PAGES.EDITING].includes(currentPage)}
                onSelected={onSelected}
            />
        </Display>
    </div>
}

interface ReadAndWriteBlackNavTabProps {
    tabName: PAGES;
    text: string;
    isSelected?: boolean;
    onSelected?: (tabName: string) => () => void;
}

const ReadAndWriteBlackNavTab: React.FC<ReadAndWriteBlackNavTabProps> = ({tabName, text, isSelected, onSelected}) => {
    return <div className={"tab " + (isSelected ? "tab-selected" : "")} onClick={onSelected(tabName)}>{text}</div>
}